import { Typography } from 'antd'

import { usePlatformCounts } from '../api/hooks'

/**
 * The platform's totals, directly under the hero.
 *
 * Drawn only when the numbers arrive. A landing page that reserves space for a
 * figure it could not fetch shows a gap where a claim should be, which reads
 * worse than never having promised one — so there is no skeleton and no zero
 * state here, just nothing until there is something.
 */
export function Counts() {
  const { data } = usePlatformCounts()

  if (!data || data.services === 0) {
    return null
  }

  return (
    <div style={{ background: '#fff', borderBottom: '1px solid #f0f0f0' }}>
      <div
        style={{
          maxWidth: 1120,
          margin: '0 auto',
          padding: '20px 24px',
          display: 'flex',
          gap: 48,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        <Figure value={data.projects} label={data.projects === 1 ? 'project' : 'projects'} />
        <Figure
          value={data.services}
          label={data.services === 1 ? 'Go service profiled' : 'Go services profiled'}
        />
      </div>
    </div>
  )
}

function Figure({ value, label }: { value: number; label: string }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <Typography.Text style={{ fontSize: 28, fontWeight: 600, display: 'block', lineHeight: 1.2 }}>
        {new Intl.NumberFormat().format(value)}
      </Typography.Text>
      <Typography.Text type="secondary" style={{ fontSize: 13 }}>
        {label}
      </Typography.Text>
    </div>
  )
}
